export default __webpack_public_path__ + "static/media/cp_zm_zoom.ead461bf.svg";